export const VERSION = '4.2.6-gogreen';
export const GIT_HASH = '856c457249673b9b91f7a2d14976cf2575f03cf1';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
